<template>
  <section class="content">
    <div class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div class="row">
            <div class="col-12">
              <h1>{{translate('messages.social_timelines')}}</h1>
            </div>
          </div>
          <div class="row">

            <div class="col-12">
          
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">{{translate('messages.social_timelines_list')}}</h3>

                  <div class="card-tools">
                    <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                        <i class="fa fa-plus-square"></i>
                        {{translate('messages.add_new')}}
                    </button>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive p-0">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>url</th>
                        <th>{{translate('messages.social_type')}}</th>
                        <th>{{translate('messages.actions')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="social_timeline in social_timelines.data" :key="'social-timeline-'+social_timeline.id">

                        <td>{{social_timeline.url}}</td>
                        <td>{{social_timeline.social_type}}</td>
                        <td>
                          
                          <a @click="editModal(social_timeline)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.update')" data-toggle="tooltip">
                              <i class="fa fa-edit blue"></i>
                          </a>
                          
                          <a @click="deleteSocialTimeline(social_timeline.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.delete')" data-toggle="tooltip">
                              <i class="fa fa-trash red"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="!social_timelines.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                    <pagination :data="social_timelines" @pagination-change-page="getResults"></pagination>
                </div>
              </div>
              <!-- /.card -->
            </div>
          </div>
      </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">{{translate('messages.create_social_timeline')}}</h5>
                    <h5 class="modal-title" v-show="editmode">{{translate('messages.update_social_timeline')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateSocialTimeline() : createSocialTimeline()">
                    <div class="modal-body">
                      <div class="form-group">
                          <label>{{translate('messages.social_type')}}</label>
                          <select class="form-control" v-model="form.social_type" :class="{ 'is-invalid': form.errors.has('social_type') }">
                            <option 
                                v-for="(st,index) in social_types" :key="'st-'+index"
                                :value="index"
                                :selected="index == form.social_type">{{ st }}</option>
                          </select>
                          <has-error :form="form" field="social_type"></has-error>
                          <p v-if="form.social_type == 'facebook'" class="form-text text-muted">
                            {{translate('messages.examples')}}: <br>
                            https://www.facebook.com/xxxxxxxx <br>
                            https://facebook.com/xxxxxxxx <br>
                          </p>
                          <p v-if="form.social_type == 'x'" class="form-text text-muted">
                            {{translate('messages.examples')}}: <br>
                            https://www.x.com/xxxxx <br>
                            https://x.com/xxxxx <br>
                          </p>
                      </div>
                      <div class="form-group">
                          <label>url</label>
                          <input v-model="form.url" type="url" name="url"
                              class="form-control" :class="{ 'is-invalid': form.errors.has('url') }">
                          <has-error :form="form" field="url"></has-error>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
      components: {
          VueTagsInput,
        },
        data () {
            return {
                editmode: false,
                social_timelines : {},
                social_types : [],
                form: new Form({
                    id : '',
                    url: '',
                    social_type : ''
                }),
                loading : true,
                page : 1
            }
        },
        methods: {

          getResults(page = 1) {

              this.$Progress.start();
              
              axios.get('/api/socialTimeline?page=' + page).then(({ data }) => {
                this.social_timelines = data.data;
                this.loading = false;
                this.$Progress.finish();
                if(!this.social_timelines.data.length && this.page > 1){
                  this.getResults(this.page - 1);
                }
              });

          },
          loadSocialTypes(){
              axios.get("/api/socialTimeline/socialTypes").then(({ data }) => {this.social_types = data.data;});
          },
          editModal(social_timeline){
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(social_timeline);
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
          },
          createSocialTimeline(){
              this.$Progress.start();
              this.form.update({_method:'post'});
              this.form.post('/api/socialTimeline')
              .then((response)=>{
                $('#addNew').modal('hide');

                Toast.fire({
                      icon: 'success',
                      title: response.data.message
                  });
                this.$Progress.finish();
                this.getResults();
              })
              .catch((error)=>{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              })
          },
          updateSocialTimeline(){
              this.$Progress.start();
              this.form.update({_method:'put'});
              this.form.post('/api/socialTimeline/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');
                  this.getResults(this.page);
              })
              .catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              });

          },
          deleteSocialTimeline(id){
            Swal.fire({
              title: window.translate('messages.are_you_sure'),
              text: window.translate('messages.no_revert'),
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.delete_confirm')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  this.form.delete('/api/socialTimeline/'+id).then((response)=>{
                    this.$Progress.finish();
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.getResults(this.page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
              })
          },

        },
        mounted() {
  
          },
        created() {
          this.getResults();
          this.loadSocialTypes();
        }
    }
</script>
